"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@alcumus/components");
const Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
const styles_1 = require("@material-ui/core/styles");
require("../../theme/SafetyIntelligenceTheme");
const AppMenu_1 = __importDefault(require("./AppMenu"));
const UserMenu_1 = __importDefault(require("./UserMenu"));
const logout_1 = require("../../../server/models/logout");
const Toast_1 = __importDefault(require("../Toast/Toast"));
const FoldersRoute_1 = __importDefault(require("../../../routes/FoldersRoute"));
const FavoriteRoute_1 = __importDefault(require("../../../routes/FavoriteRoute"));
const PopularRoute_1 = __importDefault(require("../../../routes/PopularRoute"));
const RecentRoute_1 = __importDefault(require("../../../routes/RecentRoute"));
const ReportsRoute_1 = __importDefault(require("../../../routes/ReportsRoute"));
const FolderOutlined_1 = __importDefault(require("@material-ui/icons/FolderOutlined"));
const AssessmentOutlined_1 = __importDefault(require("@material-ui/icons/AssessmentOutlined"));
const QueryBuilderOutlined_1 = __importDefault(require("@material-ui/icons/QueryBuilderOutlined"));
const FavoriteBorderOutlined_1 = __importDefault(require("@material-ui/icons/FavoriteBorderOutlined"));
const TrendingUpOutlined_1 = __importDefault(require("@material-ui/icons/TrendingUpOutlined"));
const FolderSharedOutlined_1 = __importDefault(require("@material-ui/icons/FolderSharedOutlined"));
const react_i18next_1 = require("react-i18next");
const logo_1 = require("../../constants/logo");
const useStyles = (0, styles_1.makeStyles)(() => (0, styles_1.createStyles)({
    content: {
        flexGrow: 1,
    },
    root: {
        display: 'flex',
    },
    safetyIntelligencePage: {
        padding: 0,
    },
}));
const NavBar = ({ children, disabled, t }) => {
    const personalFolderId = localStorage.getItem('personal_folder_id');
    const drawerItems = [
        {
            dataTestId: 'drawerFolders',
            title: t(FoldersRoute_1.default.friendlyName),
            href: FoldersRoute_1.default.path,
            icon: react_1.default.createElement(FolderOutlined_1.default, null),
        },
        {
            dataTestId: 'drawerReports',
            title: t(ReportsRoute_1.default.friendlyName),
            href: ReportsRoute_1.default.path,
            icon: react_1.default.createElement(AssessmentOutlined_1.default, null),
        },
        {
            dataTestId: 'drawerFavorite',
            title: t(FavoriteRoute_1.default.friendlyName),
            href: FavoriteRoute_1.default.path,
            icon: react_1.default.createElement(FavoriteBorderOutlined_1.default, null),
        },
        {
            dataTestId: 'drawerRecent',
            title: t(RecentRoute_1.default.friendlyName),
            href: RecentRoute_1.default.path,
            icon: react_1.default.createElement(QueryBuilderOutlined_1.default, null),
        },
        {
            dataTestId: 'drawerPopular',
            title: t(PopularRoute_1.default.friendlyName),
            href: PopularRoute_1.default.path,
            icon: react_1.default.createElement(TrendingUpOutlined_1.default, null),
        },
        {
            title: localStorage.getItem('user_first_name')
                ? `${localStorage.getItem('user_first_name')}'s ${t('folder')}`
                : `${t('personalFolder')}`,
            href: `${FoldersRoute_1.default.path}/${personalFolderId}`,
            icon: react_1.default.createElement(FolderSharedOutlined_1.default, null),
            dataTestId: 'drawerPersonalFolder',
            showDivider: true,
        },
    ];
    const classes = useStyles();
    return (react_1.default.createElement(components_1.Page, { className: classes.safetyIntelligencePage },
        react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement(components_1.Navigation, { logoUrl: logo_1.LOGO_URL, logoAltText: 'Ecoonline Logo', logoRedirect: "/", userContent: react_1.default.createElement(UserMenu_1.default, { onLogout: logout_1.logout }), drawerContent: react_1.default.createElement(components_1.DrawerContent, { drawerItems: drawerItems }), contextChooser: react_1.default.createElement(AppMenu_1.default, { disabled: disabled }) }),
            react_1.default.createElement("main", { id: "safety-intelligence-v2", className: classes.content },
                react_1.default.createElement(Toast_1.default, null),
                react_1.default.createElement(Toolbar_1.default, null),
                children))));
};
exports.default = (0, react_i18next_1.withTranslation)(['translation', 'AriaLabels'])(NavBar);
